import {
  instance,
} from './index';

const getTablets = async (masterUser) => {
  const res = await instance.get(`/tablets/all/${masterUser}`);
  return res;
};
const getTablet = async (id) => {
  const res = await instance.get(`/tablets/${id}`);
  return res;
};
const updateTablet = async (data) => {
  const res = await instance.put('/tablets', data);
  return res;
};
const clearTablets = async (masterUser) => {
  const res = await instance.delete(`/tablets/all/${masterUser}`);
  return res;
};
export {
  getTablets,
  getTablet,
  updateTablet,
  clearTablets,
};
